import type { IRestaurant } from '@/interfaces/IRestaurant';

/**
 * The store after an «Ajustes» save. `PUT /restaurants/:id` answers the bare
 * entity, without what only `/full` carries (`branches`, `settings`, `club`,
 * the storefront look `storefrontStyle`, `bannerMeta`, `logoColor`): every
 * field of the answer replaces the current one and every other field is kept,
 * so the pages that read them («Diseño y estilo», «Lo más pedido», GPTHelp's
 * `restaurant.design`) keep working until the next `/full` load. Another
 * store's answer is never mixed with the current store.
 */
export function restaurantAfterUpdate(
  current: IRestaurant | null | undefined,
  answer: IRestaurant
): IRestaurant {
  return current && current.id === answer.id
    ? { ...current, ...answer }
    : answer;
}

/**
 * Whether the look `restaurantAfterUpdate` kept may be stale: `/full` derives
 * `logoColor` from the logo, `bannerMeta` from the banner, and a never-themed
 * store's `storefrontStyle` from its logo colour or else its name. A save that
 * changed one of them, or a store that was not the current one (nothing kept),
 * needs the look read again from `/full`.
 */
export function lookInputsChanged(
  previous: IRestaurant | null | undefined,
  answer: IRestaurant
): boolean {
  return (
    !previous ||
    previous.id !== answer.id ||
    previous.name !== answer.name ||
    (previous.logo ?? null) !== (answer.logo ?? null) ||
    (previous.banner ?? null) !== (answer.banner ?? null)
  );
}
